import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import Icon, { IconType } from 'components/Icon';
import DownloadsMenuItem from 'components/Widget/DownloadsMenuItem';
import { Loader } from 'components/Widget/Loader';
import { ReactNode, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectUser } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as S from './styles';

interface Props {
	children: ReactNode;
}

const ExportDropdown = ({ children }: Props) => {
	const theme = useTheme();
	const [open, setOpen] = useState(false);
	const hasPendingExport = useSelector(
		(r: RootReducer) =>
			selectUser(r.db)?.metadata?.recentExports?.some((e) => e.status === 'pending') ?? false,
		shallowEqual
	);

	return (
		<RadixDropdown.Root open={open} onOpenChange={setOpen}>
			<S.Trigger>
				{hasPendingExport && <Loader size={14} />}
				Export
				<S.Chevron $open={open}>
					<Icon type={IconType.FILLED_ARROW_DOWN} width={12} height={12} color={theme.gray[0]} />
				</S.Chevron>
			</S.Trigger>
			<RadixDropdown.Portal>
				<S.Content side="bottom" sideOffset={8} align="end">
					{children}
					<DownloadsMenuItem />
				</S.Content>
			</RadixDropdown.Portal>
		</RadixDropdown.Root>
	);
};

export default ExportDropdown;
